import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { MapPin } from "lucide-react";
import { optimizeSupabaseImage, IMAGE_SIZES } from "@/utils/imageOptimization";

interface FeaturedArtisanCardProps {
  id: string;
  shopName: string;
  location?: string;
  avatarUrl?: string;
}

export function FeaturedArtisanCard({ id, shopName, location, avatarUrl }: FeaturedArtisanCardProps) {
  return (
    <Link to={`/maker/${id}`} className="group block">
      <div className="rounded-lg border bg-card p-6 text-center transition-shadow hover:shadow-md">
        <Avatar className="mx-auto mb-4 h-16 w-16">
          <AvatarImage 
            src={optimizeSupabaseImage(avatarUrl, IMAGE_SIZES.artisanAvatar)} 
            alt={shopName} 
            width={64} 
            height={64} 
          />
          <AvatarFallback className="text-lg">
            {shopName.charAt(0)}
          </AvatarFallback>
        </Avatar>
        
        <h3 className="font-semibold text-card-foreground group-hover:text-primary transition-colors">
          {shopName}
        </h3>
        
        {location && (
          <div className="mt-2 flex items-center justify-center gap-1 text-sm text-muted-foreground">
            <MapPin className="h-3 w-3" />
            {location}
          </div>
        )}
      </div>
    </Link>
  );
}